module.exports = __webpack_public_path__ + "img/ic-pw-show.788754e2.svg";